define(
({
  "alert": "Figyelem",
  "okay": "Rendben"
})
);
